module.exports = __webpack_public_path__ + "img/fhir-logo.92d5505e.png";